import { Link, useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  const columns = [
    {
      title: "Plateforme",
      links: [
        { label: "Hébergements", path: "/hotels" },
        { label: "Restaurants", path: "/restaurants" },
        { label: "Guides touristiques", path: "/guides" },
        { label: "Transports", path: "/transports" },
        { label: "Loisirs & Culture", path: "/loisirs" },
        { label: "Artisans & Marchés", path: "/artisans" },
      ],
    },
    {
      title: "Destinations",
      links: [
        { label: "Dakar", path: "/destinations/dakar" },
        { label: "Saly", path: "/destinations/saly" },
        { label: "Saint-Louis", path: "/destinations/saint-louis" },
        { label: "Casamance", path: "/destinations/casamance" },
        { label: "Ziguinchor", path: "/destinations/ziguinchor" },
      ],
    },
    {
      title: "Entreprise",
      links: [
        { label: "Notre mission", path: "/mission" },
        { label: "Devenir partenaire", path: "/contact" },
        { label: "Investisseurs", path: "/contact" },
        { label: "Contact", path: "/contact" },
      ],
    },
  ];

  // Numéro WhatsApp officiel de SenuTour (au format international, sans espaces ni +)
  const WHATSAPP_NUMERO = "221782395722";

  return (
    <>
      <style>{`
        .footer-link {
          font-family: 'Space Grotesk', sans-serif;
          font-size: 13px;
          color: rgba(255,255,255,.26);
          margin-bottom: 9px;
          cursor: pointer;
          transition: color .2s;
          text-decoration: none;
          display: block;
        }
        .footer-link:hover { color: rgba(255,255,255,.75); }
        .footer-grid {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 32px;
          margin-bottom: 36px;
        }
        @media(max-width:767px) {
          .footer-grid { flex-direction: column; gap: 28px; }
        }
      `}</style>

      <footer style={{ background: "#120B04", padding: "48px 5% 28px" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          <div className="footer-grid">

            {/* ── Logo & description ── */}
            <div style={{ maxWidth: 260 }}>
              <Link to="/" style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12, textDecoration: "none" }}>
                <div style={{ width: 28, height: 28, borderRadius: 7, background: "#C4441A", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="white">
                    <path d="M12 2C8 6 4 8 4 14a8 8 0 0 0 16 0c0-6-4-8-8-12z"/>
                  </svg>
                </div>
                <span style={{ fontFamily: "'Fraunces', serif", fontSize: 18, fontWeight: 800, color: "white" }}>
                  Senu<span style={{ color: "#E8834A" }}>Tour</span>
                </span>
                <span style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 9, fontWeight: 700, background: "rgba(196,68,26,.25)", color: "#E8834A", padding: "2px 6px", borderRadius: 3 }}>
                  BETA
                </span>
              </Link>
              <p style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 13, color: "rgba(255,255,255,.28)", lineHeight: 1.7 }}>
                La startup touristique du Sénégal. Construite par des Sénégalais, pour le monde entier.
              </p>

              {/* Réseaux sociaux */}
              <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
                {[
  {
    href: `https://wa.me/${WHATSAPP_NUMERO}`,
    icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M17.6 6.32A7.85 7.85 0 0 0 12.05 4c-4.37 0-7.92 3.55-7.92 7.92 0 1.4.37 2.76 1.07 3.96L4 20l4.24-1.11a7.9 7.9 0 0 0 3.8.97h.01c4.37 0 7.92-3.55 7.92-7.92a7.87 7.87 0 0 0-2.37-5.62zm-5.55 12.2h-.01a6.57 6.57 0 0 1-3.35-.92l-.24-.14-2.5.65.67-2.44-.16-.25a6.58 6.58 0 0 1-1.01-3.5c0-3.64 2.96-6.6 6.6-6.6a6.56 6.56 0 0 1 4.67 1.94 6.56 6.56 0 0 1 1.93 4.66c0 3.64-2.96 6.6-6.6 6.6zm3.62-4.94c-.2-.1-1.17-.58-1.35-.64-.18-.07-.32-.1-.45.1-.13.2-.51.64-.63.77-.12.13-.23.15-.43.05-.2-.1-.83-.3-1.58-.97a5.94 5.94 0 0 1-1.1-1.36c-.11-.2-.01-.3.09-.4.09-.1.2-.23.3-.35.1-.12.13-.2.2-.33.07-.13.03-.25-.02-.35-.05-.1-.45-1.08-.61-1.48-.16-.39-.32-.33-.45-.34-.11-.01-.25-.01-.38-.01-.13 0-.35.05-.53.25-.18.2-.7.68-.7 1.66s.72 1.93.82 2.06c.1.13 1.41 2.16 3.42 3.02.48.21.85.33 1.14.42.48.15.92.13 1.26.08.38-.06 1.17-.48 1.34-.94.16-.46.16-.86.11-.94-.05-.08-.18-.13-.38-.23z"/></svg>
  },
  {
    href: "https://www.instagram.com/senutour/",
    icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
  },
  {
    href: "https://www.facebook.com/profile.php?id=61593861091254",
    icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
  },
  {
    href: "https://www.tiktok.com/@senutour7",
    icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.76a4.85 4.85 0 0 1-1.01-.07z"/></svg>
  },
  {
    href: "https://www.linkedin.com/company/senutour-s%C3%A9n%C3%A9gal-546797431/",
    icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
  },
].map((s, i) => (
  <a key={i} href={s.href} target="_blank" rel="noreferrer"
    style={{ width: 32, height: 32, borderRadius: 8, background: "rgba(255,255,255,.08)", display: "flex", alignItems: "center", justifyContent: "center", transition: "background .2s" }}
    onMouseEnter={e => e.currentTarget.style.background = "rgba(196,68,26,.4)"}
    onMouseLeave={e => e.currentTarget.style.background = "rgba(255,255,255,.08)"}
  >
    {s.icon}
  </a>
))}
              </div>
            </div>

            {/* ── Colonnes de liens ── */}
            {columns.map((col, i) => (
              <div key={i}>
                <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 10, fontWeight: 700, color: "rgba(255,255,255,.3)", textTransform: "uppercase", letterSpacing: 2, marginBottom: 14 }}>
                  {col.title}
                </div>
                {col.links.map(l => (
                  <Link key={l.label} to={l.path} className="footer-link">{l.label}</Link>
                ))}
              </div>
            ))}
          </div>

          {/* ── Bande inscription partenaire ── */}
          <div style={{ background: "rgba(196,68,26,.12)", border: "1px solid rgba(196,68,26,.2)", borderRadius: 12, padding: "20px 24px", marginBottom: 28, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 16 }}>
            <div>
              <p style={{ fontFamily: "'Fraunces', serif", fontSize: 16, fontWeight: 700, color: "white", marginBottom: 4 }}>
                Vous avez un hébergement, restaurant ou service ?
              </p>
              <p style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 13, color: "rgba(255,255,255,.5)", margin: 0 }}>
                Inscrivez-vous gratuitement sur SenuTour et accédez à des milliers de touristes.
              </p>
            </div>
            <button
              onClick={() => navigate("/inscription")}
              style={{ background: "#C4441A", color: "white", border: "none", padding: "11px 22px", borderRadius: 8, fontFamily: "'Space Grotesk', sans-serif", fontSize: 13, fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap", transition: "background .2s" }}
              onMouseEnter={e => e.currentTarget.style.background = "#A03614"}
              onMouseLeave={e => e.currentTarget.style.background = "#C4441A"}
            >
              S'inscrire gratuitement →
            </button>
          </div>

          {/* ── Copyright ── */}
          <div style={{ borderTop: "1px solid rgba(255,255,255,.06)", paddingTop: 20, display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
            <span style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 12, color: "rgba(255,255,255,.2)" }}>
              © 2026 SenuTour · Startup sénégalaise 🇸🇳
            </span>
            <span style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 12, color: "rgba(255,255,255,.2)" }}>
              Teranga · Innovation · Tourisme local
            </span>
          </div>
        </div>
      </footer>
    </>
  );
}